import { Empty } from "antd";

import { AppStrings } from "../../../utils/constants/AppStrings";
import type { PokerConfigurationPageDefinition } from "../../../utils/constants/poker/pokerConfigurationData";
import { PokerConfigurationShell } from "./PokerConfigurationShell";

import styles from "./PokerConfigurationPlaceholder.module.css";

type PokerConfigurationPlaceholderProps = {
  page: PokerConfigurationPageDefinition;
};

export function PokerConfigurationPlaceholder({
  page,
}: PokerConfigurationPlaceholderProps) {
  return (
    <PokerConfigurationShell page={page}>
      <div className={styles.content}>
        <Empty description={AppStrings.POKER_CONFIG_COMING_SOON} />
      </div>
    </PokerConfigurationShell>
  );
}
